import React from "react";
import PropTypes from "prop-types";

import { Card, Divider, Space, Typography } from "antd";

import { formatAmount } from "../../../../../../constants/marketplaceCheckout";

const { Text, Title } = Typography;

/**
 * Récapitulatif produits + livraison = total, tel que calculé par le backend.
 * Tant que la livraison n'est pas chiffrée, frais et total restent "—".
 */
const OrderSummary = ({ productAmount, deliveryCost, totalAmount, currency }) => (
    <Card>
        <Title level={5} style={{ marginTop: 0 }}>Récapitulatif</Title>
        <Space orientation="vertical" style={{ width: "100%" }}>
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text>Produits</Text>
                <Text strong>{formatAmount(productAmount, currency)}</Text>
            </Space>
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text>Livraison</Text>
                <Text strong>{formatAmount(deliveryCost, currency)}</Text>
            </Space>
            <Divider style={{ margin: "4px 0" }} />
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text style={{ fontSize: 16 }}>Total</Text>
                <Text strong style={{ fontSize: 16 }}>{formatAmount(totalAmount, currency)}</Text>
            </Space>
        </Space>
    </Card>
);

OrderSummary.propTypes = {
    productAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    deliveryCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currency: PropTypes.string
};

export default OrderSummary;
